import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Input from 'components/core/Input/Input';
import Icon, { IconName } from 'components/core/Icon/Icon';
import { copyToClipboard } from 'utilities/global';

interface IProps {
  className?: string;
  textToCopy: string;
  withLabel?: boolean;
  label?: string;
  inputValue?: string;
}

const CopyToClipboard = ({
  className,
  textToCopy,
  withLabel,
  label = 'copy',
  inputValue
}: IProps) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);
    copyToClipboard(textToCopy);
    setTimeout(() => setIsCopied(false), 2000);
  };

  const Copy = () => (
    <Wrapper className={className} data-testid="copy" onClick={handleCopy}>
      <StyledIcon
        data-testid="copy_icon"
        name={isCopied ? IconName.CHECK : IconName.COPY}
      />
      {withLabel && <Text>{t(label)}</Text>}
    </Wrapper>
  );

  if (inputValue) {
    return (
      <StyledInput
        value={isCopied ? t('info_alert.copied_to_clipboard') : inputValue}
        onClick={handleCopy}
        hideDeleteButton
        readOnly
        onMouseDown={event => event.preventDefault()}
        fieldBoxProps={{
          addonAfter: <Copy />
        }}
      />
    );
  }

  return <Copy />;
};

export default CopyToClipboard;

const Wrapper = styled.div`
  display: flex;
  cursor: pointer;
`;

const StyledIcon = styled(Icon)`
  font-size: 2.4rem;

  &:hover {
    color: ${({ theme }) => theme.colors.disabled};
  }
`;

const Text = styled.span`
  margin-left: 0.5rem;
`;

const StyledInput = styled(Input)`
  width: 36rem;
  margin: 2.2rem 0 4rem 0;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;

  [data-testid*='copy_icon'] {
    font-size: ${({ theme }) => theme.fonts.size.large};
  }
`;
